import React from 'react';
import { Typography, Box } from '@mui/material';

const Licao: React.FC = () => {
  return (
    <div className="licao-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Lições
      </Typography>
      <Box>
        <Typography variant="body1">
          Página de lições em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default Licao; 